import { useLocalStorageState, useSafeState } from 'ahooks';
import { useEffect } from 'react';
import { config } from '@/utils/config';
import { WechatUserInfoType } from '@/interface';
import { queryCreateWechatAccount, queryWechatAccountInfo } from '@/service';
export default function useGlobal() {
  const AuthURL = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.appId}&redirect_uri=${config.redirect_uri}&response_type=code&scope=${config.scope}&state=${config.state}#wechat_redirect`;

  const [isAuthorized, setIsAuthorized] = useSafeState(false);
  const [code] = useSafeState(
    new URLSearchParams(window.location.search).get('code'),
  );
  const [openId, setOpenId] = useLocalStorageState<string | undefined>(
    'openId',
    {
      listenStorageChange: true,
    },
  );
  const [accessToken, setAccessToken] = useLocalStorageState<
    string | undefined
  >('accessToken', {
    listenStorageChange: true,
  });
  const [userInfo, setUserInfo] = useLocalStorageState<WechatUserInfoType>(
    'userInfo',
    {},
  );

  const [wechatAccountInfo, setWechatAccountInfo] = useLocalStorageState<any>(
    'wechatAccountInfo',
    {
      listenStorageChange: true,
    },
  );

  useEffect(() => {
    if (openId && accessToken) {
      setIsAuthorized(true);
    }
  }, [openId, accessToken]);

  const handleQueryWechatAccountInfo = async () => {
    // const wechatAccountInfo = await queryWechatAccountInfo(
    //   window.localStorage.getItem('userOpenId') || '',
    // );
    // setWechatAccountInfo(wechatAccountInfo?.data);
  };

  const check = async () => {
    if (userInfo?.openid) {
      if (wechatAccountInfo?.openId) {
        await handleQueryWechatAccountInfo();
      } else {
        // await queryCreateWechatAccount({
        //   city: userInfo.city,
        //   country: userInfo.country,
        //   headImgUrl: userInfo.headimgurl,
        //   nickName: userInfo.nickname,
        //   openId: userInfo.openid,
        //   province: userInfo.province,
        //   sex: userInfo.sex,
        // });
      }
      return;
    }
    if (code) {
      const response = await fetch(
        `${location.origin}/wechatApi/sns/oauth2/access_token?appid=${config.appId}&secret=${config.secret}&code=${code}&grant_type=authorization_code`,
      );
      const data = await response.json();
      console.log(data, 'wechat data');
      if (data.errcode) {
        // 重新跳转到授权页面
        window.location.href = AuthURL;
        console.error('Authorization failed:', data);
      }
      const { access_token, openid } = data;
      // 用户已授权，可以进行后续操作
      setIsAuthorized(true);
      // 保存 access_token 和 openid 到本地存储或发送到后端

      setOpenId(openid);
      window.localStorage.setItem('userOpenId', openid);
      setAccessToken(access_token);
      
      // 获取头像的接口
      const uerInfoResponse = await fetch(`
     ${location.origin}/wechatApi/sns/userinfo?access_token=${access_token}&openid=${openid}&lang=zh_CN
      `);
      const userInfo = await uerInfoResponse.json();
      // 创建微信账户 用不上
      // await queryCreateWechatAccount({
      //   city: userInfo.city,
      //   country: userInfo.country,
      //   headImgUrl: userInfo.headimgurl,
      //   nickName: userInfo.nickname,
      //   openId: userInfo.openid,
      //   province: userInfo.province,
      //   sex: userInfo.sex,
      // });
      setUserInfo(userInfo);
      // alert(2)
      await handleQueryWechatAccountInfo();
    } else {
      window.location.href = AuthURL;
    }
  };

  useEffect(() => {
    check();
  }, []);

  return {
    openId,
    accessToken,
    isAuthorized,
    userInfo,
    wechatAccountInfo,
    handleQueryWechatAccountInfo,
  };
}
